import 'braid-design-system/reset';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider as UnistoreProvider } from 'react-unistore';

import { App } from './App/App';
import { ConfigProvider } from './modules/appConfig';
import type { ClientContext } from './render';
import addGlobalMethods from './setup/addGlobalMethods';
import './setup/polyfills';
import { createSsoClient } from './setup/createSsoClient';
import { addStoreListeners, createStore } from './store';

export default function renderClient({
  initialPageData,
  config,
}: ClientContext) {
  const store = createStore(initialPageData);
  const { environment, site } = config;

  const timeoutAnalytics = () => ({ hasAnalyticsTimedOut: true });
  setTimeout(store.action(timeoutAnalytics), 4000);

  store.ssoClient = createSsoClient({
    environment,
    site,
  });

  addStoreListeners({ store });
  addGlobalMethods({ store });

  hydrateRoot(
    document.getElementById('app') as Element,
    <ConfigProvider config={config}>
      <BrowserRouter>
        <UnistoreProvider value={store}>
          <App />
        </UnistoreProvider>
      </BrowserRouter>
    </ConfigProvider>,
  );
}
